<template>
    <div class="historyCompare">
        <div class="shareBanner">
            <p v-if="type == '3'">欧洲杯历届对比</p>
            <p v-else-if="type != '' && num == '0'">欧洲杯</p>
            <p v-else-if="type != '3' && num != '0' && num <= 3">欧洲杯小组赛{{arr[num]}}</p>
            <p v-else>欧洲杯淘汰赛{{arr[num]}}</p>
            <span>本届与历届【<i v-if="type == '1'">指数</i><i v-if="type == '2'">比分</i>对比】</span>
        </div>
        <div class="main" v-if="origin">
            <div class="tab" :style="isShare == 1 ? 'padding:0 10/2px' : ''">
                <div class="tabBox" :style="isShare == 1 ? 'padding:0 5/2px' : ''">
                    <div class="tabOne" v-if="isShare == 0">
                        <p :class="type == 1 ? 'active': ''" @click="type = 1">指数
                            <span></span>
                        </p>
                        <p :class="type == 2 ? 'mid active': 'mid'" @click="type = 2">
                            <i>比分</i>
                            <span :style="type == 2 ? 'border-right-color: #143CDB;' : ''"></span>
                        </p>
                    </div>
                    <div class="tabAll" v-show="type != 3 && isShare == 0">
                        <van-tabs v-model="num">
                            <van-tab v-for="(item,index) in arr" :key="index" :title="item">
                            </van-tab>
                        </van-tabs>
                    </div>
                </div>
            </div>
            <template v-if="turnData">
                <historyIndex v-show="type == 1" :turnData="turnData"></historyIndex>
                <historyScore v-show="type == 2" :turnData="turnData.score"></historyScore>
            </template>
        </div>
        <template v-if="isShare == 0">
            <div class="seizeASeat"></div>
            <div class="button">
                <!-- <share></share> -->
                <div class="share">
                    <div class="shareBox">
                        <p @click="shareImg">立即分享</p>
                    </div>
                </div>
            </div>
        </template>
        <div v-else class="download">
            <div class="downloadBox">
                <p id="download">立即下载</p>
            </div>
        </div>
        <div class="placeholder"></div>
    </div>
</template>

<script>
import { getCupEuropeDataCalc } from "../../../api/activity";
import { getQueryVariable } from "../../../utils/base";
import { importSdk } from "@/utils/tools";
import jsbridg from "@/utils/jsbridg.js";
import historyIndex from "./historyIndex.vue";
import historyScore from "./historyScore.vue";
export default {
    name: 'historyCompare',
    components: {
        historyIndex,
        historyScore
    },
    data () {
        return {
            arr: ['全部', '第一轮', '第二轮', '第三轮', '十六强', '八强', '四强', '决赛'],
            num: Number(getQueryVariable('num')) || 0,
            type: getQueryVariable('type') || 1,
            uid: '',
            isShare: parseInt(getQueryVariable('isShare')) || 0,
            origin: null,
            turnData: null,
            data: [],
            isApp: false,
            img: ''
        }
    },
    created () {
        this.initData()
    },
    mounted () {
        document.getElementsByTagName('title')[0].innerHTML = '历届对比';
        if (this.isShare === 1) {
            importSdk("https://web.cdn.openinstall.io/openinstall.js", this.initOpenInstall);
        }
    },
    watch: {
        $route () {
            this.isShare = parseInt(getQueryVariable('isShare')) || 0
            this.num = Number(getQueryVariable('num')) || 0
            this.type = getQueryVariable('type') || 1
        },
        num () {
            if (this.num === 0) {
                this.turnData = this.origin.all
            }
            if (this.num === 1) {
                this.turnData = this.origin.first_round
            }
            if (this.num === 2) {
                this.turnData = this.origin.two_round
            }
            if (this.num === 3) {
                this.turnData = this.origin.three_round
            }
            if (this.num === 4) {
                this.turnData = this.origin.sixteen_final
            }
            if (this.num === 5) {
                this.turnData = this.origin.eight_final
            }
            if (this.num === 6) {
                this.turnData = this.origin.four_final
            }
            if (this.num === 7) {
                // this.turnData = this.origin['3_4']
                this.turnData = this.origin.final
            }
            if (this.num === 8) {
                this.turnData = this.origin.final
            }
        }
    },
    methods: {
        initOpenInstall () {
            /* eslint-disable*/
            var data = OpenInstall.parseUrlParams();///openinstall.js中提供的工具函数，解析url中的所有查询参数
            new OpenInstall({
                /*appKey必选参数，OpenInstall平台为每个应用分配的ID*/
                appKey : process.env.VUE_APP_OPENINSTALLAPPKEY,
                onready : function() {
                    /*在app已安装的情况尝试拉起app*/
                    this.schemeWakeup();
                    /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                    var m = this;
                    var btn_1 = document.getElementById('download');
                    btn_1.style.visibility = "visible";
                    btn_1.onclick = function() {
                        m.wakeupOrInstall();
                        return false;
                    }
                }
            }, data);
        },
        // 历届对比数据
        async initData () {
            const res = await getCupEuropeDataCalc({
                sport_id: 1,
                league_id: 67
            });
            if (res.errno === 0) {
                this.origin = res.data.list;
                if (this.num === 0) {
                    this.turnData = this.origin.all
                }
                if (this.num === 1) {
                    this.turnData = this.origin.first_round
                }
                if (this.num === 2) {
                    this.turnData = this.origin.two_round
                }
                if (this.num === 3) {
                    this.turnData = this.origin.three_round
                }
                if (this.num === 4) {
                    this.turnData = this.origin.sixteen_final
                }
                if (this.num === 5) {
                    this.turnData = this.origin.eight_final
                }
                if (this.num === 6) {
                    this.turnData = this.origin.four_final
                }
                if (this.num === 7) {
                    // this.turnData = this.origin['3_4']
                    this.turnData = this.origin.final
                }
                if (this.num === 8) {
                    this.turnData = this.origin.final
                }
            } else {
                this.$toast(res.msg)
            }
        },
        shareImg () {
            const shareobj = {
                title: `2024欧洲杯「本届与历届对比（${this.type == 1 ? '指数' : '比分'}）」`,
                desc: '下载即嗨体育查看更多欧洲杯数据',
                link: `${process.env.VUE_APP_DOMAIN}/activity/cup/europe?type=${this.type}&num=${this.num}&isShare=1`,
                imgUrl: 'https://s.jihai8.com/pc/images/download/qrcode-logo.png'
            }
            jsbridg.appShare(shareobj);
        }
    }
}
</script>

<style lang="less" scoped>
.historyCompare {
    min-height: 100vh;
    // background:  #143CDB;
    background: #F7FBFF;
    text-align: center;
    .returnTips{
        position: fixed;
        left: 32/2px;
        top: 40/2px;
        width: 100%;
        display: flex;
        align-items: center;
        .btn{
            width: 136/2px;
            height: 60/2px;
            background: rgba(255,255,255,0.1);
            border-radius: 70/2px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10/2px;
            .returnIcon{
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 36/2px;
                color: #fff;
            }
            .line{
                height: 20/2px;
                width: 1/2px;
                background-color: #fff;
            }
        }
    }
    .shareBanner {
        height: 370/2px;
        background-image: url('../../../assets/img/activity/cup/ljdbBanner.png');
        background-repeat: no-repeat;
        background-size: 100% 330/2px;
        background-color: #143CDB;
        padding-top: 80px;
        p {
            font-family: Kanit-bold;
            font-size: 56/2px;
            color: #EFCA97;
            font-weight: bold;
            // background: linear-gradient(-90deg, #E8BE84 0%, #FFF6D9 100%);
        }
        span{
            color: #ffffff;
            font-size: 26/2px;
        }
    }
    .main{
        border-radius: 32/2px 32/2px 0/2px 0/2px;
        margin-top: -40/2px;
        background-color: #F7FBFF;
        z-index: 2;
        position: relative;
        // border: 1/2px solid;
        border-image: linear-gradient(180deg, rgba(136, 150, 212, 1), rgba(71, 78, 110, 1)) 1 1;
        overflow: hidden;
    }
    .tab {
        padding: 0/2px 20/2px;
        position: relative;
        z-index: 1;
        .tabBox {
            padding: 0 10/2px;
            padding-top: 16/2px;
            border-radius: 4/2px 4/2px 0 0;
            .tabOne {
                display: flex;
                justify-content: space-between;
                p {
                    width: 331/2px;
                    height: 80/2px;
                    line-height: 80/2px;
                    font-size: 28/2px;
                    border-radius: 61/2px;
                    border: 1/2px solid #637A85;
                    font-size: 30/2px;
                    color: #637A85;
                }
                .active {
                    background: linear-gradient( 90deg, #F8EDCC 0%, #EFCA97 100%);
                    color: #723B23;
                    border-color: transparent;
                }
            }
            .tabAll {
                margin-top: -1/2px;
                // padding: 0 10/2px;
                /deep/ .van-tabs__nav--line.van-tabs__nav--complete {
                    padding-left: 0;
                    padding-right: 0;
                }
                /deep/ .van-tabs__line {
                    width: 20/2px;
                    height: 8/2px;
                    background: #723B23;
                    border-radius: 0;
                }
                /deep/ .van-tab {
                    font-size: 28/2px;
                    font-weight: 400;
                    color: #666666;
                }
                /deep/.van-tabs__nav{
                    background-color: transparent;
                }
                /deep/ .van-tab--active {
                    font-size: 28/2px;
                    font-weight: bold;
                    color: #723B23;
                }
            }
            .championTeatm {
                    height: 250/2px;
                    display: flex;
                    justify-content: space-between;
                    background: #fff;
                    border-radius: 0 0 4/2px 4/2px;
                    padding-top: 20/2px;
                    div {
                        width: 224/2px;
                        padding: 10/2px 0;
                        height: 220/2px;
                        background: #F4F8FB;
                        border: 2/2px solid #143CDB;
                        p {
                            font-size: 24/2px;
                            font-weight: 400;
                            color: #333333;
                            text-align: left;
                            padding-left: 20/2px;
                            margin-top: 8/2px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            &:first-child {
                                font-size: 28/2px;
                                font-weight: bold;
                                color: #143CDB;
                                text-align: center;
                                padding-left: 0;
                                margin-top: 0;
                            }
                        }
                    }
                }
        }
    }
    .shareText {
        height: 30/2px;
        font-size: 28/2px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 42/2px;
        text-align: center;
        margin-bottom: 40/2px;
        span {
            color: #FFC209;
        }
    }
    .download{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .downloadBox{
            display: flex;
            justify-content: center;
            align-items: center;
            p {
                width: 380/2px;
                height: 94/2px;
                background: linear-gradient(-90deg, #EFCA97, #F8EDCC);
                // border: 2/2px solid;
                // border: 2/2px solid #F0B19A;
                border-image: linear-gradient(0deg, #D5CFFF, #BC90F8) 2 2;
                border-radius: 48/2px;
                font-size: 34/2px;
                font-weight: bold;
                color: #723B23;
                line-height: 94/2px;
            }
        }
    }
    .seizeASeat{
        height: 94/2px;
    }
    .button {
        position: fixed;
        width: 100%;
        bottom: 20/2px;
        z-index: 3;
        .share {
            .shareBox {
                display: flex;
                justify-content: center;
                align-items: center;
                p {
                    width: 380/2px;
                    height: 94/2px;
                    background: linear-gradient(-90deg, #EFCA97, #F8EDCC);
                    // border: 2/2px solid;
                    // border: 2/2px solid #F0B19A;
                    border-image: linear-gradient(0deg, #D5CFFF, #BC90F8) 2 2;
                    border-radius: 48/2px;
                    font-size: 34/2px;
                    font-weight: bold;
                    color: #723B23;
                    line-height: 94/2px;
                }
            }
        }
    }
    .placeholder{
        width: 100%;
        height: 20px;
    }
}
</style>
